import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NetworkConstants, appAccessOptionsUserRolesData, deepCopy, generateId, removeUndefined, rightsOptionsUserRolesData, rightsUserRoles, usRolesDataAccess } from 'diwimamodelweb/lib';
import { usRolesSettingForm } from '../model/form';
import { UserFeedbackService } from '../user-feedback.service';
import { UserRolesDataAccessDialogComponent } from '../user-roles-data-access-dialog/user-roles-data-access-dialog.component';
import { SettingsService } from '../settings.service';
import { firstValueFrom, skipWhile, take } from 'rxjs';

@Component({
  selector: 'app-user-roles-form',
  templateUrl: './user-roles-form.component.html',
  styleUrls: ['./user-roles-form.component.css', '../../app.component.scss']
})

export class UserRolesFormComponent {
  @Input() data: usRolesSettingForm
  @Input() formBuilder: FormBuilder
  @Input() translateService: TranslateService

  deleteRight = false
  updateRight = false
  usRolesForm: FormGroup
  isCreate = false
  appAccessList = appAccessOptionsUserRolesData
  rightsList = rightsUserRoles//rightsOptionsUserRolesData
  dataAccessInfo: any = []

  constructor(private userFeddback: UserFeedbackService,
    private settingsService: SettingsService) {}

  async ngOnInit(): Promise<void> {

    const context = await firstValueFrom(this.settingsService.selectedUserContext$.pipe(
      skipWhile(el => !el),
      take(1)
    ))
    const rights = this.settingsService.rightsPercontext.get(context.identifier)
    this.updateRight = !rights?.['contextsettings']?.['U'] ?? true
    this.deleteRight = !rights?.['contextsettings']?.['D'] ?? true

    this.usRolesForm = this.formBuilder.group({
      title: [, Validators.required],
      identifier: [, Validators.required],
      sortIndex: [],
      // rights: [],
      appAccess: [],
      dataAccess: [],
      titles:[]
    })
    if (this.data.data) this.initialitzeWithData()
    else{
      this.isCreate = true
      this.usRolesForm.patchValue({identifier: generateId(6)})
    }

  }

  initialitzeWithData(){
    const {title, sortIndex, identifier, appAccess, dataAccess, /*rights*/} = this.data.data 
    this.dataAccessInfo = deepCopy(dataAccess)
    this.usRolesForm.patchValue({ title, sortIndex, identifier, appAccess: appAccess ?appAccess :[] , dataAccess: dataAccess ? dataAccess : [] })
    this.usRolesForm.get('dataAccess').valueChanges.subscribe( (v) => {
      this.dataAccessInfo = v
    })
  }

  onCreateDataAccess(){
    this.userFeddback.showDialog.emit({
      entryComponent: UserRolesDataAccessDialogComponent,
      title: "",
      message: "",
      data: {values: false, dataAccessInfo: this.dataAccessInfo, },
      cancleCallback: async () => { },
      positiveCallback: async (data)=> {
        if( !this.updateRight ) {
          this.userFeddback.loading.emit(true)
          const alldata = this.dataAccessInfo ?? []
          alldata.push(data)
          this.usRolesForm.patchValue({dataAccess: alldata})
          this.userFeddback.loading.emit(false)
        }
      }
    })
  }

  onEditDataAccess(data, index){
    this.userFeddback.showDialog.emit({
      entryComponent: UserRolesDataAccessDialogComponent,
      title: this.translateService.instant('FORM.userRolesForm.title'),
      message: "",
      data: {values: data, dataAccessInfo: this.dataAccessInfo, },
      cancleCallback: async () => { },
      positiveCallback: async (data)=> {
        if( !this.updateRight) {
          this.userFeddback.loading.emit(true)
          const alldata = this.usRolesForm.get('dataAccess').value
          alldata[index] = data
          this.usRolesForm.patchValue({dataAccess: alldata})
          this.userFeddback.loading.emit(false)
        }
      }
    })
  }

  onSubmit() {
    const {title, sortIndex, titles, identifier, appAccess, dataAccess, rights} = this.usRolesForm.value 

    if (this.isCreate) {
      let setting: any = {
        title,
        identifier: identifier ?? title,
        // sortIndex: sortIndex ?? this.allCategoriesNumber,
        titles: titles ?? {},
        // rights: rights ? rights : undefined,
        dataAccess: dataAccess ? dataAccess : dataAccess,
        appAccess: appAccess ? appAccess : undefined
      }
      const cleaned = removeUndefined(setting)
      this.data.onCreate(cleaned)
    } else {
      this.data.data.title = title
      this.data.data.appAccess = appAccess
      // this.data.data.rights = rights
      this.data.data.dataAccess = removeUndefined(dataAccess)
      this.data.onSubmit()
    }
  }
  onDelete(){
    this.data.onDelete(this.data)
  }

  deleteData(data, index) {
    this.dataAccessInfo.splice(index, 1)
    this.usRolesForm.patchValue({ dataAccess: this.dataAccessInfo})
  }

}
